import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import useAutoLogout from "../hooks/useAutoLogout";
import Logo from "../assets/logos/kazaslot.png";
import logSmall from "../assets/logos/logo-small.png";

function Header({ toggleSidebar, isopen }) {
  const { user, logout } = useAuth();
  useAutoLogout(user.token, logout);
  const [showHeader, setShowHeader] = useState(false);
  return (
    <nav className="navbar navbar-expand-lg">
      <div className={`container-fluid ps-0  ${isopen ? "" : "side-closed"}`}>
        {/* Brand + toggle */}
        <div className="navbar-header d-flex justify-content-md-between">
          <button
            className="navbar-toggler   d-block d-lg-none me-auto"
            type="button"
            onClick={toggleSidebar}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <a className="navbar-brand d-flex align-items-center" href="#">
            <img
              src={Logo}
              alt="Logo"
              className="d-inline-block align-text-top"
            />
          </a>
          <a
            className="navbar-toggle  navbarheader-toggle d-block d-md-none ms-auto"
            type="button"
            onClick={() => setShowHeader(!showHeader)}
          ></a>
        </div>

        {/* Nav links */}
        <div
          className={`collapse navbar-collapse d-md-inline-flex flex-md-fill  ${showHeader ? "show" : ""}`}
          id="navbarNav"
        >
          <button
            className="navbar-toggler d-none d-lg-block"
            type="button"
            onClick={toggleSidebar}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <ul className="navbar-nav ms-auto nav navbar-right flex-md-row">
            <li className="nav-item">
              <a className="nav-link p-2" href="#">
                EN
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link p-2" href="#">
                Notification
              </a>
            </li>

            <li className="nav-item user_profile">
              <span className="nav-link p-2" href="#">
                {user?.fullName}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Header;
